import { z } from 'zod';

export const schemaUploadedDocument = z.object({ key: z.string().min(1), name: z.string().min(1) });

export type SchemaUploadedDocument = z.infer<typeof schemaUploadedDocument>;

/**
 * Response body for POST /documents/upload.
 * `malwareRejectedFiles` and `malwareRejectedFormIndexes` are independent lists —
 * do not assume positional correspondence (concurrent promise mutations).
 * `malwareRejectedFormIndexes` is only populated for adviser FormData indexes; always [] for applicants.
 */
export const schemaDocumentsUploadResponse = z.object({
    error: z.string().optional(),
    errorUploadFiles: z.array(z.string()),
    malwareRejectedFiles: z.array(z.string()),
    malwareRejectedFormIndexes: z.array(z.number().int().nonnegative()),
    position: z.number().nullable().optional(),
    rejectedFiles: z.array(z.string()),
    // omitted on 4xx responses; always present on 200
    uploadedDocuments: z.array(schemaUploadedDocument).optional(),
});

export type SchemaDocumentsUploadResponse = z.infer<typeof schemaDocumentsUploadResponse>;
